/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';

import MaxLengthNumericEditor from '../../../SharedModules/CustomAgGridEditor/inputComponent';
import * as Styles from '../../../SharedModules/StyleConstant/StyleConstant';

// To red the amount in -ve

const ragRenderer = (params) => {
  // const value = params.value;
  const cellValue = params?.api?.getValue(params?.column?.colId, params?.node);
  const DisplayValue = params?.value ? params?.value : cellValue;
  if (cellValue === '') {
    return '';
  }
  let value = 0;
  if (DisplayValue?.toString()?.includes('$')) {
    value = parseFloat(DisplayValue?.split('$')[1]?.trim());
  } else {
    value = parseFloat(DisplayValue);
  }
  if (params?.data?.isBottomRow) {
    const pinnedValue = parseFloat(params?.value);
    if (pinnedValue < 0) {
      return (
        <b>
          <span
            style={{ color: '#eb0000', textAlign: 'right', display: 'inline' }}
          >
            (
            {`$ ${Math.abs(parseFloat(pinnedValue)).toLocaleString('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}`}
            )
          </span>
        </b>
      );
    }
    if (pinnedValue) {
      return (
        <div style={{ textAlign: 'right' }}>
          <b>
            {`$ ${parseFloat(pinnedValue)?.toLocaleString('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}`}
          </b>
        </div>
      );
    }
    return (
      <div style={{ textAlign: 'right' }}>
        <b>$ 0.00</b>
      </div>
    );
  }
  if (value < 0) {
    return (
      <span style={{ color: '#eb0000', textAlign: 'right', display: 'inline' }}>
        {` ($ ${Math.abs(parseFloat(value)).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}
        )`}
      </span>
    );
  }
  if (value) {
    return (
      <div style={{ textAlign: 'right' }}>{`$ ${parseFloat(
        value
      )?.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`}</div>
    );
  }
  return <div style={{ textAlign: 'right' }}>$ 0.00</div>;
};
function amountComparator(amount1, amount2) {
  let amt1 = null;
  let amt2 = null;
  if (amount1 && amount1?.toString()?.includes('$')) {
    amt1 = parseFloat(
      amount1?.toString().split('$')[1]?.toString()?.replace(',', '').trim()
    );
  } else {
    amt1 = parseFloat(amount1?.toString()?.replace(',', '').trim());
  }
  if (amount2 && amount2?.toString()?.includes('$')) {
    amt2 = parseFloat(
      amount2?.toString().split('$')[1]?.toString()?.replace(',', '').trim()
    );
  } else {
    amt2 = parseFloat(amount2?.toString()?.replace(',', '').trim());
  }
  if (amt1 === null && amt2 === null) {
    return 0;
  }
  if (amt1 === null) {
    return -1;
  }
  if (amt2 === null) {
    return 1;
  }

  return amt1 - amt2;
}
const ragRenderer1 = (params) => {
  // const value = params.value;
  const cellValue = params?.api?.getValue(params?.column?.colId, params?.node);
  const DisplayValue = params?.value ? params?.value : cellValue;
  if (cellValue === '') {
    return '';
  }
  let value = 0;
  if (DisplayValue?.toString()?.includes('$')) {
    value = parseFloat(DisplayValue?.split('$')[1]?.trim());
  } else {
    value = parseFloat(DisplayValue);
  }

  if (params?.data?.isBottomRow) {
    const pinnedValue = parseFloat(params?.value);
    if (pinnedValue < 0) {
      return (
        <b>
          <span
            style={{ color: '#eb0000', textAlign: 'right', display: 'inline' }}
          >
            ({` ${Math.abs(parseFloat(pinnedValue)).toLocaleString('en-US')}`})
          </span>
        </b>
      );
    }
    if (pinnedValue) {
      return (
        <div style={{ textAlign: 'right' }}>
          <b>{` ${parseFloat(pinnedValue)?.toLocaleString('en-US')}`}</b>
        </div>
      );
    }
    return (
      <div style={{ textAlign: 'right' }}>
        <b> 0</b>
      </div>
    );
  }
  if (value < 0) {
    return (
      <span style={{ color: '#eb0000', textAlign: 'right', display: 'inline' }}>
        {` ( ${Math.abs(parseFloat(value)).toLocaleString('en-US')}
        )`}
      </span>
    );
  }
  if (value) {
    return (
      <div style={{ textAlign: 'right' }}>{` ${parseFloat(
        value
      )?.toLocaleString('en-US')}`}</div>
    );
  }
  return <div style={{ textAlign: 'right' }}> 0</div>;
};

const comparatorQtr = (a, b) => {
  const splittedQtrA = a?.split('Q');
  const splittedQtrB = b?.split('Q');
  return splittedQtrA[1] - splittedQtrB[1] || splittedQtrA[0] - splittedQtrB[0];
};
export const RebateSummaryTableHead = [
  {
    headerName: 'QTR',
    field: 'qtr',
    editable: false,
    sortable: true,
    sort: 'desc',
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    comparator: comparatorQtr,
    wrapText: true,
    autoHeight: true,
    minWidth: Styles.Width_100,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Invoiced Data',

    children: [
      {
        headerName: 'Total Invoiced Dollar Amount',
        field: 'totalAmount',

        isTextColorRed: true,
        minWidth: Styles.Width_158,
        cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
        printPrefixValue: '$',
        cellRenderer: ragRenderer,
        comparator: amountComparator,
        editable: false,
        sortable: true,
        filter: 'agTextColumnFilter',
        wrapText: true,
        // autoHeight: true,
        filterParams: {
          defaultOption: 'startsWith',
          suppressAndOrCondition: true,
          buttons: ['reset'],
          refreshValuesOnOpen: true,
        },
      },
      {
        headerName: 'Number Of Invoices',
        field: 'invoiceNumCount',
        isTextColorRed: true,
        cellRenderer: ragRenderer1,
        comparator: amountComparator,
        minWidth: Styles.Width_130,
        cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
        editable: false,
        sortable: true,
        wrapText: true,
        excelAlignment: 'right',
        filter: 'agTextColumnFilter',
        filterParams: {
          defaultOption: 'startsWith',
          suppressAndOrCondition: true,
          buttons: ['reset'],
          refreshValuesOnOpen: true,
        },
        alignment: 'right',
      },
    ],

    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,

    minWidth: Styles.Width_100,
  },
  {
    headerName: 'Payment Received',

    children: [
      {
        headerName: 'Total Payment Received',
        field: 'totalReceivedAmt',

        isTextColorRed: true,
        minWidth: Styles.Width_158,
        cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
        editable: false,
        sortable: true,

        printPrefixValue: '$',
        comparator: amountComparator,

        cellRenderer: ragRenderer,
        filter: 'agTextColumnFilter',
        wrapText: true,
        // autoHeight: true,
        filterParams: {
          defaultOption: 'startsWith',
          suppressAndOrCondition: true,
          buttons: ['reset'],
          refreshValuesOnOpen: true,
        },
      },
      {
        headerName: 'Number Of Checks',
        field: 'numberOfChecks',
        isTextColorRed: true,
        cellRenderer: ragRenderer1,
        comparator: amountComparator,
        minWidth: Styles.Width_130,
        cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
        editable: false,
        sortable: true,
        wrapText: true,
        filter: 'agTextColumnFilter',
        excelAlignment: 'right',
        filterParams: {
          defaultOption: 'startsWith',
          suppressAndOrCondition: true,
          buttons: ['reset'],
          refreshValuesOnOpen: true,
        },
        alignment: 'right',
        isTextColorRed: true,
      },
    ],

    suppressMenu: false,
    cellRenderer: 'CheckPayeeCell',

    minWidth: Styles.Width_100,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
  },
  {
    headerName: 'In Dispute Data',

    children: [
      {
        headerName: 'Total Disputed Dollar Amount',

        printPrefixValue: '$',
        isTextColorRed: true,
        cellRenderer: ragRenderer,
        comparator: amountComparator,
        cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },

        field: 'sumOfAmount',
        minWidth: Styles.Width_158,
        editable: false,
        sortable: true,
        filter: 'agTextColumnFilter',
        wrapText: true,
        // autoHeight: true,
        filterParams: {
          defaultOption: 'startsWith',
          suppressAndOrCondition: true,
          buttons: ['reset'],
          refreshValuesOnOpen: true,
        },
      },
      {
        headerName: 'Number Of Invoices',
        isTextColorRed: true,
        cellRenderer: ragRenderer1,
        comparator: amountComparator,

        cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
        field: 'labelerCode',
        minWidth: Styles.Width_130,
        editable: false,
        sortable: true,
        excelAlignment: 'right',
        filter: 'agTextColumnFilter',
        filterParams: {
          defaultOption: 'startsWith',
          suppressAndOrCondition: true,
          buttons: ['reset'],
          refreshValuesOnOpen: true,
        },
        alignment: 'right',
        isTextColorRed: true,
      },
    ],

    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,

    minWidth: Styles.Width_100,
    cellStyle: {
      borderRightColor: Styles.BorderColor,
    },
  },
];
export const RebateSummaryTableHead2 = [
  {
    headerName: 'Year',
    field: 'year',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    wrapText: true,
    autoHeight: true,
    minWidth: Styles.Width_100,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Invoiced Data',

    children: [
      {
        headerName: 'Total Invoiced Dollar Amount',
        field: 'totalAmount',

        isTextColorRed: true,
        minWidth: Styles.Width_150,
        cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
        printPrefixValue: '$',
        comparator: amountComparator,
        cellRenderer: ragRenderer,

        editable: false,
        sortable: true,
        filter: 'agTextColumnFilter',
        wrapText: true,
        // autoHeight: true,
        filterParams: {
          defaultOption: 'startsWith',
          suppressAndOrCondition: true,
          buttons: ['reset'],
          refreshValuesOnOpen: true,
        },
      },
      {
        headerName: 'Number Of Invoices',
        field: 'invoiceNumCount',
        isTextColorRed: true,
        cellRenderer: ragRenderer1,
        comparator: amountComparator,
        minWidth: Styles.Width_110,
        cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
        editable: false,
        sortable: true,
        wrapText: true,
        excelAlignment: 'right',
        filter: 'agTextColumnFilter',
        filterParams: {
          defaultOption: 'startsWith',
          suppressAndOrCondition: true,
          buttons: ['reset'],
          refreshValuesOnOpen: true,
        },
        alignment: 'right',
      },
    ],

    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,

    minWidth: Styles.Width_100,
  },
  {
    headerName: 'Payment Received',

    children: [
      {
        headerName: 'Total Payment Received',
        field: 'totalReceivedAmt',

        isTextColorRed: true,
        minWidth: Styles.Width_150,
        cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
        editable: false,
        sortable: true,

        printPrefixValue: '$',
        comparator: amountComparator,
        cellRenderer: ragRenderer,
        filter: 'agTextColumnFilter',
        wrapText: true,
        // autoHeight: true,
        filterParams: {
          defaultOption: 'startsWith',
          suppressAndOrCondition: true,
          buttons: ['reset'],
          refreshValuesOnOpen: true,
        },
      },
      {
        headerName: 'Number Of Checks',
        field: 'numberOfChecks',
        isTextColorRed: true,
        comparator: amountComparator,

        cellRenderer: ragRenderer1,
        minWidth: Styles.Width_110,
        cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
        editable: false,
        sortable: true,
        filter: 'agTextColumnFilter',
        wrapText: true,
        excelAlignment: 'right',
        filterParams: {
          defaultOption: 'startsWith',
          suppressAndOrCondition: true,
          buttons: ['reset'],
          refreshValuesOnOpen: true,
        },
        alignment: 'right',
        isTextColorRed: true,
      },
    ],

    suppressMenu: false,
    cellRenderer: 'CheckPayeeCell',

    minWidth: Styles.Width_100,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
  },
  {
    headerName: 'In Dispute Data',

    children: [
      {
        headerName: 'Total Disputed Dollar Amount',

        printPrefixValue: '$',
        isTextColorRed: true,
        cellRenderer: ragRenderer,
        comparator: amountComparator,

        cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },

        field: 'sumOfAmount',
        minWidth: Styles.Width_150,
        editable: false,
        sortable: true,
        filter: 'agTextColumnFilter',
        wrapText: true,
        // autoHeight: true,
        filterParams: {
          defaultOption: 'startsWith',
          suppressAndOrCondition: true,
          buttons: ['reset'],
          refreshValuesOnOpen: true,
        },
      },
      {
        headerName: 'Number Of Invoices',
        isTextColorRed: true,
        comparator: amountComparator,
        cellRenderer: ragRenderer1,
        cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
        field: 'labelerCode',
        minWidth: Styles.Width_125,
        editable: false,
        sortable: true,
        excelAlignment: 'right',
        filter: 'agTextColumnFilter',
        filterParams: {
          defaultOption: 'startsWith',
          suppressAndOrCondition: true,
          buttons: ['reset'],
          refreshValuesOnOpen: true,
        },
        alignment: 'right',
        isTextColorRed: true,
      },
    ],

    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,

    minWidth: Styles.Width_100,
    cellStyle: {
      borderRightColor: Styles.BorderColor,
    },
  },
];
